<template>
    <mu-dialog dialogClass="eval-dialog" :open="showDialog" scrollable bodyClass='eval-dialog-body'>
      <mu-flexbox>
        <mu-flexbox-item class="flex-demoLeft">
          <mu-paper class="demo-paper" :zDepth="1" style="width:300px;height:300px;">
            <img :src="parent.game.scaleName ? '/static/images/assess_icons/'+parent.game.scaleName+'/icon.svg' : '/static/images/assess_icons/'+parent.game.SCALENAME+'/icon.svg'" style="width:300px;height:300px;" />
          </mu-paper>
          <h4 class="footer-left-header">{{ parent.game.scaleName }}</h4>
        </mu-flexbox-item>
        <mu-flexbox-item class="flex-demoRight" v-if="parent.startType == 2">
          <div class="body-right-head">
            <input type="text" name="" ref="search" @keyup="showAllIList" placeholder="输入搜索内容" v-model="search.keyword"/><i class="searchicon" @click="searchPeople">搜</i>
          </div>
          <div class="body-right-foot">
            <ul>
              <li v-for="(caseList,index) in caseLists" :key="index" :class="{'on':parent.flag==caseList.id}" @click="choseMe(caseList.id)" class="clearfix">
                <template v-if="caseList.name != '临时测评虚拟患者'">
                <span>{{(caseList.name+'').substr(-2,2)}}</span>
                <i :title="caseList.name">{{caseList.name}}</i>，<i v-if="caseList.gender == '1'">女</i><i v-else-if="caseList.gender == '2'">男</i><i v-else>其他</i>，{{caseList.age}}岁
                </template>
              </li>
            </ul>
          </div>
        </mu-flexbox-item>
        <mu-flexbox-item class="flex-demoRight" v-else-if="parent.startType == 1">
          <div class="body-right-head">
            <input type="text" class="searchEval" name="" placeholder="输入搜索内容" v-model="search.keyword"/><i class="searchicon" @click="searchPeople">搜</i>
          </div>
          <div class="body-right-foot">
            <ul>
              <li class="caseListEval" v-for="(caseList,index) in caseLists" :key="index" @click="choseMe(caseList.id)" :class="{'on':parent.flag==caseList.id}">
                <template v-if="caseList.name != '临时测评虚拟患者'">
                <span>{{(caseList.name+'').substr(-2,2)}}</span>
                <i>{{caseList.name}}</i>，<i v-if="caseList.gender == '1'">女</i><i v-else-if="caseList.gender == '2'">男</i><i v-else>其他</i>，{{caseList.age}}岁
                </template>
              </li>
            </ul>
            <div v-if="parent.pages==0">
              无结果
            </div>
          </div>
        </mu-flexbox-item>
      </mu-flexbox>
      <div class="footer-button-position" v-if="parent.startType == 2">
        <a href="javascript:void(0);"  @click="gotoEval(parent.caseIdDoc,parent.scaleId, parent.scaleAlias,false)" class="a-font">临时测评</a>
        <mu-raised-button label="取消" @click="closeModal" style="margin:5px 20px 0 20px;color:#999;border-radius:20px;" slot="actions" />
        <button class="button" id="justTrain" style="margin-top:5px" @click="gotoEval(parent.caseId,parent.scaleId, parent.scaleAlias,false)" disabled>开始测评</button>
      </div>

      <div class="footer-button-position" v-else-if="parent.startType == 1">
        <a href="javascript:void(0);" @click="gotoEval1(parent.caseIdDoc,parent.scaleId)" class="a-font">临时测评</a>
        <mu-raised-button label="取消" @click="closeModal" style="margin:5px 30px 0 30px;color:#999;border-radius:20px;" slot="actions" />
        <button class="button" id="justTrain" style="margin-top:5px;background-color:#f5f5f5;" @click="gotoEval1(parent.caseId,parent.scaleId)" disabled>开始测评</button>
      </div>
    </mu-dialog>
</template>

<script>
  import Vue from 'vue'

  export default ({
    props: {
      showDialog: {
        default: ()=>false,
      },
      fromHome:{},
    },
    data() {
      return {
        address: GLOBAL.cognition,
        search: {
          keyword: ''
        },
        caseLists: [],
        //第三方测评变量开始
        message: {
          initPromise: null,
          caseId: '', //病例id
          scaleId: '',//量表id
          scaleAliasName: '', //量表别名
          isRestart: false, //是否是重新测评
          // 是否开始监听message
          inited: false,
          targetWindow: null,
          modules: []
        },//第三方测评变量结束
        thirdpartyurl: g_k_urls.WAB,
        scale: {},
        parent:"",
      }
    },
    mounted(){
      console.log(this.fromHome);
      if(this.fromHome){
        this.parent = this.$parent;
      }else{
        this.parent = this.$parent.$parent;
      }
      this.searchPeople();
      window.addEventListener('message', this.messageHandler);
    },
    beforeDestroy: function () {
      window.removeEventListener('message', this.messageHandler);
    },
    methods: {
      closeModal:function(){
        this.parent.showModal=false;
        this.parent.caseId = '';
        this.parent.flag = "";
        this.parent.flag = '';
        this.search.keyword = "";
        this.$emit("close");
      },
      showAllIList:function(){
        if(this.search.keyword == ''){
          this.searchPeople();
        }
      },
      choseMe:function(caseId){
        this.parent.caseId = caseId;
        this.parent.flag = caseId;
        $(".startevm").removeProp("disabled");
        $(".startevm").removeClass("startevm");
        $("#justTrain").attr("disabled",false).css("background-color","#0a81e5");
      },
      searchPeople: function(curPage,pageNum) {
        var self = this;
        Vue.http({
            method: 'GET',
            url:'/api/Cases/getListByDt',
            params: {
              'search': this.search
            }
          })
          .then(function(res){
            self.caseLists = res.data.data;
            self.parent.pages = res.data.page.total;
          });
      },
      gotoEval:function(caseId,scaleId, scaleAliasName, isRestart){
        this.openThirdparty(caseId, scaleId, scaleAliasName, isRestart);
      },
      //1.0测评开始
      gotoEval1:function(caseId,scaleId){
        if (this.scale.uri)
        {
          // debugger;
          this.$router.push({ path: "/doc/assessment",query: { caseId: caseId, scaleId:scaleId, template_uri:this.scale.uri}});
          return;
        }
        this.$router.push({ path: "/doc/startEval/",query: { caseId: caseId, scaleId:scaleId}});
      },
      //第三方测评开始
      openThirdparty: function (caseId, scaleId, scaleAliasName, isRestart) {
        var self = this;
         _.assign(self.message, {
           caseId: caseId,
           scaleId: scaleId,
           scaleAliasName: scaleAliasName,
           isRestart: isRestart
         });
        self.initPromise = isRestart ? Promise.resolve() : Vue.http({
          method:'GET',
          url:'/api/Thirdparty/getModules',
          params:{ scaleId: scaleId, caseId: caseId }
        });
        // 为解决弹出窗口会被拦截的问题，需要设置为先打开地址然后获取模块
        self.message.targetWindow = window.open(self.thirdpartyurl + '/#!/'
          + scaleAliasName + '?origin=' + location.origin + (isRestart ? '&restart=restart' : ''));
        self.message.inited = true;
        self.initPromise.then(function (result) {
          if (result) {
            self.message.caseId=result.data.data.uid;
            self.message.modules = result.data.data.modules;
            self.message.lastDay = result.data.data.lastDay;
          }
        });
      },
      messageHandler: function (data) {
        var self = this;
        // 页面当开第三方测评后才开始监听
        if (self.message.inited) {
          if (data.data.source && data.data.source === 'thirdparty') {
            switch (data.data.message) {
              // 页面加载完成
              case 'opened':
                  console.log('打开：');
                var postData = { source: 'rehab', message: 'start', aliasName: self.message.scaleAliasName };
                if (!self.message.isRestart) {
                   _.assign(postData, { modules: this.message.modules, lastDay: this.message.lastDay });
                }
                // 数据获取完成后再发送消息
                self.initPromise.then(function () {
                  // 开始测评消息
                  self.message.targetWindow.postMessage(postData,self.thirdpartyurl);
                });
                break;
              // 获取模块具体完成信息
              case 'module:status':
                console.log('状态：');
                var moduleIndex = data.data.moduleIndex;
                Vue.http({
                  method:'GET',
                  url:'/api/Thirdparty/getModuleStatus',
                  params:{
                    scaleId: self.message.scaleId,
                    caseId: self.message.caseId,
                    moduleIndex: moduleIndex
                  }
                })
                .then(function (result) {
                  self.message.targetWindow.postMessage({
                    source: 'rehab',
                    message: 'module:status:ok',
                    aliasName: self.message.scaleAliasName,
                    module: result.data
                  }, self.thirdpartyurl);
                });
                break;
              // 更新模块信息
              case 'module:update':
                console.log('更新：');
                self.$http.post('/api/Thirdparty/updateModule', {
                  scaleId: self.message.scaleId,
                  caseId: self.message.caseId,
                  moduleIndex: data.data.index,
                  time: data.data.time,
                  module: data.data.module
                }, {emulateJSON: true})
                .then(function (result) {
                  self.message.targetWindow.postMessage({
                    source: 'rehab',
                    message: 'module:update:ok'
                  },self.thirdpartyurl);
                });
                break;
              // 提交测评，生成报告
              case 'commit':
                console.log('提交：');
                self.$http.post('/api/Thirdparty/commit', {
                  scaleId: self.message.scaleId,
                  caseId: self.message.caseId
                }, {emulateJSON: true})
                .then(function (result) {
                  self.message.targetWindow.postMessage({ source: 'rehab', message: 'commit:ok' }, self.thirdpartyurl);
                  if (result.data.resultCode === 20000) {
                    console.log('commit is ok!!');
                    self.$router.push({ path: '/doc/cases/evalRecord/'+self.message.caseId,query: { reId: result.data.reportId}});
                  }
                });
                break;
            }
          }
        }
      }
      //第三方测评结束
    }
  })
</script>

<style lang="stylus" scoped>
  .dialogClass
    width 800px!important
    height 500px!important
    max-width 800px!important
    max-height 500px!important
  .mu-dialog-body
    margin-top 8px
  .flex-demoLeft
    max-width 336px
  .flex-demoRight
    margin-top -30px
    margin-right 6px
  .demo-paper
    margin-left 6px
    margin-top 8px
    position relative
    top 8px
  .body-right-head
    position relative
    background-color #fff
    height 40px
    line-height 40px
  .body-right-head input
    width 100%
    height 40px
    margin-top 6px
    line-height 40px
    padding-left 20px
    background-color #f5f5f5
    outline none
  .body-right-head i
    text-indent -9999px
    position absolute
    margin-top 6px
    top 0
    right 0
    display inline-block
    width 40px
    height 40px
    border-radius 100px
    background #0A81E5 url("../../../assets/img/search.png") no-repeat center
  .body-right-foot
    margin 30px 0
    height 240px
    overflow auto
  ul li
    line-height 99px
    margin-top 0
    margin-right 30px
    text-align left
    border-bottom 1px solid #eee
    cursor pointer
  ul li span
    color #fff
    background-color #F6A623
    display inline-block
    width 47px
    height 47px
    line-height 50px
    border-radius 100px
    text-align center
  ul li:nth-child(4n+1) span
    background-color #1BBE9F!important
  ul li:nth-child(4n+2) span
    background-color #F6A623!important
  ul li:nth-child(4n+3) span
    background-color #E8570F!important
  ul li:nth-child(4n+0) span
    background-color #4990E2!important
  ul li i
    font-style normal
    font-weight bold
    margin-left 10px
    display inline-block
    vertical-align middle
    height 47px
    line-height 47px
    max-width 100px
    text-align center
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
  .footer-container
    height 80px
    clear both
  .footer-left
    float left
    width 45%
  /*.footer-left h4
    margin 5px 0
    text-align left*/
  .footer-left-header
    margin-left 6px
    margin-top 15px
  .footer-left p
    margin 0
    text-align left
  .footer-right
    float right
    width 50%
    position relative
  .footer-down
    position absolute
    top 54px
    right 0
  .a-font
    font-size 14px
    color #333
    text-decoration underline
  .footer-down button
    margin 0 0 0 30px
    outline none!important
  .footer-button-position
    text-align right
    margin-top 30px
    margin-right 6px
  p.sec-p
    padding:0 0 0 -100px!important
  .on
    position relative
    /*background-color #eee*/
  .on::before
    content: '';
    position:absolute;
    top:35px;
    right:20px;
    display:inline-block!important;
    margin-left:30px;
    width:20px;
    height:20px;
    background-image: url('../../../assets/img/icon_select_blue.png');
  .clearfix {*zoom: 1;}
  .clearfix:after {display: table;line-height: 0;content: "";clear: both;}

  .startevm
    cursor not-allowed
    background #ddd!important
  .searchicon
    cursor:pointer
</style>



// WEBPACK FOOTER //
// evalContentmodal.vue?c0f41304